import React from 'react';
import _ from 'lodash';
import Loader from '../components/loader';
import Success from '../images/Success.svg';
import Error from '../images/Error.svg';
import '../css/projectdetailaddpage.css';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { TextField } from '@mui/material';
// import uniqid from 'uniqid';
import errorText from './../errorText';
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
import Style from 'style-it';
import mc from '../images/mc.svg';
import ab from '../images/ab.svg';
import uvodb from '../images/uvodb.svg';
import vodb from '../images/vodb.svg';
import ml from '../images/ml.svg';
import { RxCross2 } from 'react-icons/rx';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper } from "@mui/material";


let noOfFloors = [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
    { label: 6, value: 6 },
    { label: 7, value: 7 },
    // { label: 8, value: 8 },

];

class ProjectDetailEditPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            okasBoxData: [],
            projectmanagerdata1: [],
            memberLicenseTemp: [],
            memberLicenseToUpload: [],
            memberLicenseData: [],
            kk: 'asdvhj',
            showSome: false,
            okasBox_type: "",
            building_type: "",
            building_name: "",
            owner_name: "",
            address: "",
            no_of_floors: "",
            no_of_users: "",
            no_of_rooms: "",
            project_manager: "",
            office_address: "",
            okasBox_id: "",
            owner_phone: "",
            owner_email: "",
            textvaluetest: [],
            textvaluetest1: [],
            textvaluetest2: [],
            textvaluetest3: [],
            textvaluetest4: [],
            textvaluetest5: [],
            textvaluetest6: [],
            textvaluetest7: [],
            checkboxes: {},
            okasboxid: '',
            registrationid: '',
            licenceid: "",
            okasBoxType: "",
            buildingtype: "",
            buildingname: "",
            ownername: "",
            ownerphone: "",
            owneremail: "",
            buildingaddress: "",
            noOfFloors: "",
            nousers: "",
            norooms: "2",
            projectmanager: "",
            officeaddress: "",
            okasboxid: "",
            noofCount: 0,
            error: '',
            nameerror: '',
            disabledvalue: '',
            totalokasboxcount: '',
            okasbox1: '',
            okasbox2: '',
            okasbox3: '',
            okasbox4: '',
            okasbox5: '',
            okasbox6: '',
            loader: '',
            currentPage: 1,
            todosPerPage: 10,
            successmsgmodaldata: localStorage.getItem('dataadded'),
            showmodels: '',
            modelname: '',
            modelxname: '',
            checkedBoxes: '',
            checkedBoxestemp: [],
            radio: false,
            radio1: false,
            demobox1: 0,
            demobox2: 0,
            demobox3: 0,
            demobox4: 0,
            demobox5: 0,
            demobox6: 0,
            demobox7: 0,
        };
    }

    checkuserApi = (checkUserAdmin) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/userCheckApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(checkuserApidata => {
                // checkuserApidata = {
                //     "first_name": "OKAS Training",
                //     "User_Type": "3",
                //     "user_name": "training@vyom.ai",
                //     "status": "200"
                // }
                if (checkuserApidata.User_Type === '1') {
                    checkUserAdmin(true)
                } else {
                    checkUserAdmin(false)
                }
            })
    }

    componentWillMount() {


        // console.log(this.props.redux.globalVar.userTypeStyle)
        this.checkuserApi((checkUserAdmin) => {
            if (checkUserAdmin) {
                this.unassignedMemberLicense();
            }
        });

        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                })
            }
                .bind(this),
            3000
        );


        var getParams = function (url) {
            var params = {};
            var parser = document.createElement('a');
            parser.href = url;
            var query = parser.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < 1; i++) {
                var pair = vars[i].split('=');
                params[pair[0]] = decodeURIComponent(pair[1]);
            }
            return params;
        };

        // console.log(getParams(window.location.href).buildingid)
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        // fetch('/we/we/projectBuilding_DetailApi/'+getParams(window.location.href).buildingid ,{
        fetch('/we/we/projectBuildingApi_detail/' + getParams(window.location.href).buildingid, {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxDataget => {
                console.log("No of floors", okasBoxDataget.no_of_floors)
                this.setState({
                    okasBoxDataget,
                    buildingname: okasBoxDataget.building_name,
                    ownername: okasBoxDataget.owner_name,
                    ownerphone: okasBoxDataget.owner_no,
                    owneremail: okasBoxDataget.owner_email,
                    buildingaddress: okasBoxDataget.address,
                    noOfFloors: okasBoxDataget.no_of_floors,
                    nofloorstemp: okasBoxDataget.no_of_floors,
                    nousers: okasBoxDataget.no_of_users,
                    nouserstemp: okasBoxDataget.no_of_users,
                    buildingtype: okasBoxDataget.building_type,
                    okasboxid: okasBoxDataget.okasBox_id,
                    building_id: okasBoxDataget.building_id,
                    office_address: okasBoxDataget.office_address,
                    project_manager: okasBoxDataget.project_manager,
                    project_managerid: okasBoxDataget.pm_id,
                    memberLicenseIdToUpload: okasBoxDataget.licence_id
                }, () => {
                    this.renderTableData();
                    noOfFloors = [];
                    for (var x = this.state.noOfFloors; x <= 7; x++) {
                        noOfFloors.push({ label: x, value: x })
                    }

                    fetch('/we/we/okastabledata/', {
                        method: "GET",
                        headers: headers
                    })
                        .then(response => response.json())
                        .then(okasBoxData => {
                            this.setState({
                                okasBoxData
                            }, () => {
                                this.renderTableData();
                                this.renderTableDataedit('mastercontrollerbox')
                                this.renderTableDataedit('vodbox')
                                // this.renderTableDataedit('UVOD Box')
                                this.renderTableDataedit('musicbox')
                                // this.renderTableDataedit('hometheaterbox')
                                this.renderTableDataedit('controlStudio')
                                this.renderTableDataedit('coreOkasbox')
                            })
                        })


                })
            })
        //     console.log(this.props.location)
        //     let TokenValue = 'Token '+localStorage.getItem("auth");
        //     var headers = {
        //       'Content-Type': 'application/json',
        //       'Authorization': TokenValue
        //   } 
    }

    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
            nameerror: '',
        })
        this.errormsg();
    }

    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }

    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }
                .bind(this), 3000
        );
    }
    onopenmodel = (modelname, modelxname) => {
        if (modelxname === 'memberlicense') {
            this.setState({
                memberLicenseTemp: this.state.memberLicenseToUpload
            }, () => {
                this.setState({
                    showmodels: 'true',
                    modelname: modelname,
                    modelxname: modelxname,
                    checkedBoxes: this.state.checkedBoxestemp,
                    error: false,
                })
            })
        } else {
            this.setState({
                showmodels: 'true',
                modelname: modelname,
                modelxname: modelxname,
                checkedBoxes: this.state.checkedBoxestemp,
                error: false,
            })
        }
    }

    onclosemodel = (event) => {
        this.setState({
            showmodels: '',
        })
    }

    checkresltimebox(checkvalue) {
        let valursft;
        const listItems1 = Object.entries(this.state.checkedBoxes).map(([key, value]) => {
            if (value.name == checkvalue) {
                valursft = value.presentValue;
                return valursft
            }
        })
        return valursft;
    }



    handleChange(e) {
        this.setState({
            checkedBoxestemp: this.state.checkedBoxes,
        })

        let oldArray = this.state.checkedBoxes;
        let current = this.state.checkedBoxes;
        let textvalue = [];
        let textvalue1 = [];
        let textvalue2 = [];
        let textvalue3 = [];
        let textvalue4 = [];
        let textvalue5 = [];
        let textvalue6 = [];
        let textvalue7 = [];


        const listItems = Object.entries(oldArray).map(([key, value]) => {
            console.log(value);


            if (value.boxType == "Master Controller") {
                if (value.presentValue === true) {
                    textvalue1.push(value.name)
                    textvalue.push(value.name)
                    this.setState({
                        textvaluetest1: textvalue1,
                        textvaluetest: textvalue,
                    })
                }
                if (value.presentValue === false) {

                    this.setState({
                        textvaluetest1: textvalue1,
                        textvaluetest: textvalue,
                    })
                }
            }

            if (value.boxType == "VOD Box") {
                if (value.presentValue === true) {
                    textvalue.push(value.name)
                    textvalue2.push(value.name)
                    this.setState({
                        textvaluetest2: textvalue2,
                        textvaluetest: textvalue,
                    })
                }
                if (value.presentValue === false) {

                    this.setState({
                        textvaluetest2: textvalue2,
                        textvaluetest: textvalue,
                    })
                }
            }

            if (value.boxType == "UVOD Box") {
                if (value.presentValue === true) {
                    textvalue.push(value.name)
                    textvalue3.push(value.name)
                    this.setState({
                        textvaluetest3: textvalue3,
                        textvaluetest: textvalue,
                    })
                }
                if (value.presentValue === false) {

                    this.setState({
                        textvaluetest3: textvalue3,
                        textvaluetest: textvalue,
                    })
                }
            }

            if (value.boxType == "Audio Box") {
                if (value.presentValue === true) {
                    textvalue.push(value.name)
                    textvalue4.push(value.name)
                    this.setState({
                        textvaluetest4: textvalue4,
                        textvaluetest: textvalue,
                    })
                }
                if (value.presentValue === false) {

                    this.setState({
                        textvaluetest4: textvalue4,
                        textvaluetest: textvalue,
                    })
                }
            }

            if (value.boxType == "Control Studio") {
                if (value.presentValue === true) {
                    textvalue6.push(value.name)
                    textvalue.push(value.name)
                    this.setState({
                        textvaluetest6: textvalue6,
                        textvaluetest: textvalue,
                    })
                }
                if (value.presentValue === false) {

                    this.setState({
                        textvaluetest6: textvalue6,
                        textvaluetest: textvalue,
                    })
                }
            }

            if (value.boxType == "Home Theatre Box") {
                if (value.presentValue === true) {
                    textvalue.push(value.name)
                    textvalue5.push(value.name)
                    this.setState({
                        textvaluetest5: textvalue5,
                        textvaluetest: textvalue,
                    })
                }
                if (value.presentValue === false) {

                    this.setState({
                        textvaluetest5: textvalue5,
                        textvaluetest: textvalue,
                    })
                }
            }

            if (value.boxType == "Core Okas") {
                if (value.presentValue === true) {
                    textvalue.push(value.name)
                    textvalue5.push(value.name)
                    this.setState({
                        textvaluetest7: textvalue7,
                        textvaluetest: textvalue,
                    })
                }
                if (value.presentValue === false) {

                    this.setState({
                        textvaluetest7: textvalue7,
                        textvaluetest: textvalue,
                    })
                }
            }



            // if(value.presentValue===true){  
            //     textvalue.push(value.name) 
            //         this.setState({ 
            //             textvaluetest: textvalue,
            //         })   
            //     if(value.boxType=="Master Controller"){  
            //         textvalue1.push(value.name)
            //         this.setState({ 
            //             textvaluetest1: textvalue1,
            //         })    
            //     } 
            //     if(value.boxType=="VOD Box"){  

            //         textvalue2.push(value.name)
            //         this.setState({ 
            //             textvaluetest2: textvalue2,
            //         })    
            //     } 
            //     if(value.boxType=="UVOD Box"){  
            //         textvalue3.push(value.name)
            //         this.setState({ 
            //             textvaluetest3: textvalue3,
            //         })    
            //     } 
            //     if(value.boxType=="Audio Box"){  
            //         textvalue4.push(value.name)
            //         this.setState({ 
            //             textvaluetest4: textvalue4,
            //         })    
            //     } 
            //     if(value.boxType=="Home Theatre Box"){  
            //         textvalue5.push(value.name)
            //         this.setState({ 
            //             textvaluetest5: textvalue5,
            //         })    
            //     } 

            // }  

            this.onclosemodel()
        })
    }




    componentDidUpdate() {
        // console.log(this.state.textvalue);




    }
    componentDidMount() {

        // console.log(this.props.location)
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        fetch('/we/we/projectManagerApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(projectmanagerdata1 => {
                this.setState({
                    projectmanagerdata1
                }, () => {
                    this.renderTableData();
                    // console.log(this.state.projectmanagerdata1)
                })
            })

    }
    getChckeboxValue(event) {
        const value = event.target.value;
        // console.log(value)
    }



    renderTableDataedit = (type) => {
        console.log(type, this.state.okasBoxData, this.state.okasboxid,)
        if (type === 'mastercontrollerbox') {
            let count1 = 0;

            let xx = this.state.okasBoxData.map((e, index) => {
                // console.log("198,199,311".split(","))
                if (e.okasBox_type === 'Master Controller' && this.state.okasboxid.split(",").includes(e.okasBox_id.toString())) {
                    count1++;
                    // console.log(e.okasBox_id)
                    this.setState({
                        demobox1: count1
                    })
                }
            });
            return xx;
        }


        if (type === 'vodbox') {
            let count2 = 0;
            let xx = this.state.okasBoxData.map((e, index) => {
                if (e.okasBox_type === 'VOD Box' && this.state.okasboxid.split(",").includes(e.okasBox_id.toString())) {
                    count2++;
                    this.setState({
                        demobox2: this.state.demobox2 + count2
                    })
                }
                // console.log("VOD Box Count:", count2); // Logs the count in console

            });
            return xx;
        }
        if (type === 'UVOD Box') {
            let count3 = 0;
            let xx = this.state.okasBoxData.map((e, index) => {
                if (e.okasBox_type === 'UVOD Box' && this.state.okasboxid.split(",").includes(e.okasBox_id.toString())) {
                    count3++;
                    this.setState({
                        demobox3: this.state.demobox3 + count3
                    })
                }
            });
            return xx;
        }
        if (type === 'musicbox') {
            let count = 0;
            let xx = this.state.okasBoxData.map((e, index) => {
                // if (e.okasBox_type === 'Audio Box' && _.includes(this.state.okasboxid, e.okasBox_id)) {
                if (e.okasBox_type === 'Audio Box' && this.state.okasboxid.split(",").includes(e.okasBox_id.toString())) {
                    count++;
                    this.setState({
                        demobox4: this.state.demobox4 + count
                    })
                }
            });
            return xx;
        }
        if (type === 'controlStudio') {
            let count = 0;

            let xx = this.state.okasBoxData.map((e, index) => {

                if (e.okasBox_type === 'Control Studio' && this.state.okasboxid.split(",").includes(e.okasBox_id.toString())) {
                    count++;


                    this.setState({
                        demobox6: this.state.demobox6 + count
                    })
                }
            });
            return xx;
        }
        if (type === 'coreOkasbox') {
            let count = 0;
            let xx = this.state.okasBoxData.map((e, index) => {
                if (e.okasBox_type === 'Core Okas' && this.state.okasboxid.split(",").includes(e.okasBox_id.toString())) {
                    count++;
                    this.setState({
                        demobox7: this.state.demobox7 + count
                    })
                }
            });
            return xx;
        }
        if (type === 'hometheaterbox') {
            let count = 0;
            let xx = this.state.okasBoxData.map((e, index) => {
                if (e.okasBox_type === 'Home Theatre Box' && this.state.okasboxid.split(",").includes(e.okasBox_id.toString())) {
                    console.log('5')
                    count++;
                    this.setState({
                        demobox5: this.state.demobox5 + count
                    })
                }
            });
            return xx;
        }

    }


    renderTableData1 = (type, managerName) => {
        if (type === 'renderprojectdata') {
            var typee = 0;
            let office_locationunique = this.state.projectmanagerdata1;
            office_locationunique = _.uniqBy(office_locationunique, 'office_location');
            let xxx = office_locationunique.map((e, index) => {
                return (
                    <option key={index}>{e.office_location}</option>
                )
            });
            return xxx;
        }
        if (type === 'renderprojectdatalocation') {
            var typee = 0;
            let xxx = this.state.projectmanagerdata1.map((e, index) => {
                if (e.office_location === managerName) {
                    return (
                        <option key={index} value={e.id}>{e.first_name}</option>
                    )
                }
            });
            return xxx;
        }
    }

    renderTableDataOfficeLocation = (managerName) => {
        let xxx = this.state.projectmanagerdata1.map((e, index) => {
            if (e.name === managerName) {
                return (
                    <option key={index}>{e.office_location}</option>
                )
            }
        });
        return xxx;
    }


    renderTableData = (type) => {


        if (this.state.okasBoxData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }
        if (type === 'mastercontrollerbox') {
            var typee = 0;
            let count = 0;
            let tempcount = 0;
            let xx = this.state.okasBoxData.map((e, index) => {
                console.log(e)
                // console.log( this.state.okasboxid.split(',').length)
                // console.log([this.state.okasboxid].length)
                // console.log( _.includes(this.state.okasboxid,e.okasBox_id))
                if (e.okasBox_type === 'Master Controller' && (e.okasBox_assigned_to === 'unassigned' || this.state.okasboxid.split(",").includes(e.okasBox_id.toString()))) {
                    // && this.state.okasboxid.split(",").includes(e.okasBox_id.toString())) {
                    typee = typee + 1;
                    let dd = _.indexOf(this.state.textvalue1, e.okasBox_id);
                    let x = e.okasBox_id
                    if (_.includes(this.state.okasboxid, e.okasBox_id) === 'true') {

                    }
                    count++
                    return (
                        <tr key={index}>
                            {this.props.redux.globalVar.userTypeStyle === '1' && <td>
                                <input type="checkbox" name={e.okasBox_type}
                                    onChange={(ee) => {
                                        // console.log(ee.target.checked);
                                        this.setState({
                                            checkedBoxes: {
                                                ...this.state.checkedBoxes,
                                                [x]: {
                                                    'name': x,
                                                    'presentValue': ee.target.checked,
                                                    'boxType': e.okasBox_type
                                                }
                                            }
                                        })
                                    }}
                                    checked={_.includes(this.state.okasboxid, e.okasBox_id) ? 'true' : this.checkresltimebox(x)}
                                    value={e.okasBox_id} />
                            </td>}
                            {/* <td>{e.okasBox_id}</td>  */}

                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"}>
                                <span className="input-checkbox-mobile">
                                    {this.props.windowWidth <= 760 ? <input type="checkbox" name={e.okasBox_type}
                                        onChange={(ee) => {
                                            console.log(ee.target.checked);
                                            this.setState({
                                                checkedBoxes: {
                                                    ...this.state.checkedBoxes,
                                                    [x]: {
                                                        'name': x,
                                                        'presentValue': ee.target.checked,
                                                        'boxType': e.okasBox_type
                                                    }
                                                }
                                            })
                                        }}
                                        checked={_.includes(this.state.okasboxid, e.okasBox_id) ? 'true' : this.checkresltimebox(x)}
                                        value={e.okasBox_id} /> : null}

                                </span>
                                {e.okasBox_type === 'Master Controller' ? 'Master Studio' : e.okasBox_type}
                            </td>
                            <td
                                className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"}
                            >
                                {e.okasBox_serialNo}
                            </td>
                        </tr>

                    )
                }
            });
            if (count === 0) {
                xx =
                    (<tr>
                        <td colSpan='4' className="text-center">
                            No box available in Inventory
                        </td>
                    </tr>)

            }
            return xx;
        }


        else if (type === 'coreOkasbox') {
            let count = 0;
            let xx1 = this.state.okasBoxData.map((e, index) => {
                if (e.okasBox_type === 'Core Okas' && (e.okasBox_assigned_to === 'unassigned' || this.state.okasboxid.split(",").includes(e.okasBox_id.toString()))) {
                    let x = e.okasBox_id
                    count++;
                    return (
                        <tr key={index}>
                            {this.props.redux.globalVar.userTypeStyle === '1' && <td>
                                <input type="checkbox" name={e.okasBox_type}
                                    onChange={(ee) => {
                                        console.log(ee.target.checked);
                                        this.setState({
                                            checkedBoxes: {
                                                ...this.state.checkedBoxes,
                                                [x]: {
                                                    'name': x,
                                                    'presentValue': ee.target.checked,
                                                    'boxType': e.okasBox_type
                                                }
                                            }
                                        })
                                    }}
                                    checked={_.includes(this.state.okasboxid, e.okasBox_id) ? 'true' : this.checkresltimebox(x)}
                                    value={e.okasBox_id} /></td>}
                            {/* <td>{e.okasBox_id}</td>  */}
                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"} >
                                <span className="input-checkbox-mobile">
                                    {this.props.windowWidth < 760 ? <input type="checkbox" name={e.okasBox_type}
                                        onChange={(ee) => {
                                            console.log(ee.target.checked);
                                            this.setState({
                                                checkedBoxes: {
                                                    ...this.state.checkedBoxes,
                                                    [x]: {
                                                        'name': x,
                                                        'presentValue': ee.target.checked,
                                                        'boxType': e.okasBox_type
                                                    }
                                                }
                                            })
                                        }}
                                        checked={_.includes(this.state.okasboxid, e.okasBox_id) ? 'true' : this.checkresltimebox(x)}
                                        value={e.okasBox_id} /> : null}
                                </span>
                                {e.okasBox_type === 'Core Okas' ? 'Core OKAS' : e.okasBox_type}
                            </td>
                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"} >{e.okasBox_serialNo}</td>
                        </tr>
                    )
                }
            });
            if (count === 0) {
                xx1 =
                    (<tr>
                        <td colSpan='4' className="text-center">
                            No box available in Inventory
                        </td>
                    </tr>)

            }
            return xx1;
        }




        else if (type === 'vodbox') {
            let count = 0;
            let xx1 = this.state.okasBoxData.map((e, index) => {
                console.log("nji", e);
                if (e.okasBox_type === 'VOD Box' && (e.okasBox_assigned_to === 'unassigned' || this.state.okasboxid.split(",").includes(e.okasBox_id.toString()))) {
                    let x = e.okasBox_id
                    count++;
                    return (
                        <tr key={index}>
                            {this.props.redux.globalVar.userTypeStyle === '1' && <td>
                                <input type="checkbox" name={e.okasBox_type}
                                    onChange={(ee) => {
                                        console.log(ee.target.checked);
                                        this.setState({
                                            checkedBoxes: {
                                                ...this.state.checkedBoxes,
                                                [x]: {
                                                    'name': x,
                                                    'presentValue': ee.target.checked,
                                                    'boxType': e.okasBox_type
                                                }
                                            }
                                        })
                                    }}
                                    checked={this.state.okasboxid.split(",").includes(e.okasBox_id.toString()) ? 'true' : this.checkresltimebox(x)}
                                    value={e.okasBox_id} /></td>}
                            {/* <td>{e.okasBox_id}</td>  */}
                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"} >
                                <span className="input-checkbox-mobile">
                                    {this.props.windowWidth < 760 ? <input type="checkbox" name={e.okasBox_type}
                                        onChange={(ee) => {
                                            // console.log(ee.target.checked);
                                            this.setState({
                                                checkedBoxes: {
                                                    ...this.state.checkedBoxes,
                                                    [x]: {
                                                        'name': x,
                                                        'presentValue': ee.target.checked,
                                                        'boxType': e.okasBox_type
                                                    }
                                                }
                                            })
                                        }}
                                        checked={this.state.okasboxid.split(",").includes(e.okasBox_id.toString()) ? 'true' : this.checkresltimebox(x)}
                                        value={e.okasBox_id} /> : null}
                                </span>
                                {e.okasBox_type === 'VOD Box' ? 'Media Studio' : e.okasBox_type}
                            </td>
                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"} >{e.okasBox_serialNo}</td>
                        </tr>
                    )
                }
            });
            if (count === 0) {
                xx1 =
                    (<tr>
                        <td colSpan='4' className="text-center">
                            No box available in Inventory
                        </td>
                    </tr>)

            }
            return xx1;
        }
        else if (type === 'UVOD Box') {
            let count = 0;
            let xx1 = this.state.okasBoxData.map((e, index) => {
                if (e.okasBox_type === "UVOD Box" && (e.okasBox_assigned_to === 'unassigned' || _.includes(this.state.okasboxid, e.okasBox_id))) {
                    let x = e.okasBox_id
                    count++
                    return (
                        <tr key={index}>
                            {this.props.redux.globalVar.userTypeStyle === '1' && <td><input type="checkbox" name={e.okasBox_type}
                                onChange={(ee) => {
                                    this.setState({
                                        checkedBoxes: {
                                            ...this.state.checkedBoxes,
                                            [x]: {
                                                'name': x,
                                                'presentValue': ee.target.checked,
                                                'boxType': e.okasBox_type
                                            }
                                        }
                                    })
                                }}
                                checked={this.state.okasboxid.split(",").includes(e.okasBox_id.toString()) ? 'true' : this.checkresltimebox(x)}
                                value={e.okasBox_id} /></td>}
                            {/* <td>{e.okasBox_id}</td>  */}
                            {/* <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"}>
                                <span className="input-checkbox-mobile">
                                    {this.props.windowWidth < 760 ? <input type="checkbox" name={e.okasBox_type}
                                        onChange={(ee) => {
                                            this.setState({
                                                checkedBoxes: {
                                                    ...this.state.checkedBoxes,
                                                    [x]: {
                                                        'name': x,
                                                        'presentValue': ee.target.checked,
                                                        'boxType': e.okasBox_type
                                                    }
                                                }
                                            })
                                        }}
                                        checked={_.includes(this.state.okasboxid, e.okasBox_id) ? 'true' : this.checkresltimebox(x)}
                                        value={e.okasBox_id} /> : null}
                                </span>
                                {e.okasBox_type === 'UVOD Box' ? 'Ultra Media Studio' : e.okasBox_type}
                            </td> */}
                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"}>{e.okasBox_serialNo}</td>
                        </tr>
                    )
                }
            });
            if (count === 0) {
                xx1 =
                    (<tr>
                        <td colSpan='4' className="text-center">
                            No box available in Inventory
                        </td>
                    </tr>)

            }
            return xx1;
        }
        else if (type === 'musicbox') {
            let count = 0;
            let xx1 = this.state.okasBoxData.map((e, index) => {
                if (e.okasBox_type === "Audio Box" && (e.okasBox_assigned_to === 'unassigned' || this.state.okasboxid.split(",").includes(e.okasBox_id.toString()))) {
                    let x = e.okasBox_id
                    count++
                    return (
                        <tr key={index}>
                            {this.props.redux.globalVar.userTypeStyle === '1' && <td><input type="checkbox" name={e.okasBox_type}
                                onChange={(ee) => {
                                    // console.log(ee.target.checked);
                                    this.setState({
                                        checkedBoxes: {
                                            ...this.state.checkedBoxes,
                                            [x]: {
                                                'name': x,
                                                'presentValue': ee.target.checked,
                                                'boxType': e.okasBox_type
                                            }

                                        }
                                    })
                                }}
                                checked={this.state.okasboxid.split(",").includes(e.okasBox_id.toString()) ? 'true' : this.checkresltimebox(x)}
                                value={e.okasBox_id} /></td>}
                            {/* <td>{e.okasBox_id}</td>  */}
                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"}>
                                <span className="input-checkbox-mobile">
                                    {this.props.windowWidth < 760 ? <input type="checkbox" name={e.okasBox_type}
                                        onChange={(ee) => {
                                            // console.log(ee.target.checked);
                                            this.setState({
                                                checkedBoxes: {
                                                    ...this.state.checkedBoxes,
                                                    [x]: {
                                                        'name': x,
                                                        'presentValue': ee.target.checked,
                                                        'boxType': e.okasBox_type
                                                    }

                                                }
                                            })
                                        }}
                                        checked={this.state.okasboxid.split(",").includes(e.okasBox_id.toString()) ? 'true' : this.checkresltimebox(x)}
                                        value={e.okasBox_id} /> : null}
                                </span>
                                {e.okasBox_type === 'Audio Box' ? 'Music Studio' : e.okasBox_type}
                            </td>
                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"}>{e.okasBox_serialNo}</td>
                        </tr>
                    )
                }
            });
            if (count === 0) {
                xx1 =
                    (<tr>
                        <td colSpan='4' className="text-center">
                            No box available in Inventory
                        </td>
                    </tr>)

            }
            return xx1;
        }
        else if (type === 'controlStudio') {
            let count = 0;
            let xx = this.state.okasBoxData.map((e, index) => {
                if (e.okasBox_type === 'Control Studio' && (e.okasBox_assigned_to === 'unassigned' || this.state.okasboxid.split(",").includes(e.okasBox_id.toString()))) {
                    let x = e.okasBox_id
                    count++
                    return (
                        <tr key={index}>
                            {this.props.redux.globalVar.userTypeStyle === '1' && <td>
                                <input type="checkbox" name={e.okasBox_type}
                                    onChange={(ee) => {
                                        this.setState({
                                            checkedBoxes: {
                                                ...this.state.checkedBoxes,
                                                [x]: {
                                                    'name': x,
                                                    'presentValue': ee.target.checked,
                                                    'boxType': e.okasBox_type
                                                }
                                            }
                                        })
                                    }}
                                    checked={this.state.okasboxid.split(",").includes(e.okasBox_id.toString()) ? 'true' : this.checkresltimebox(x)}
                                    value={e.okasBox_id} />
                            </td>}
                            {/* <td>{e.okasBox_id}</td>  */}

                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"}>
                                <span className="input-checkbox-mobile">
                                    {this.props.windowWidth <= 760 ? <input type="checkbox" name={e.okasBox_type}
                                        onChange={(ee) => {
                                            this.setState({
                                                checkedBoxes: {
                                                    ...this.state.checkedBoxes,
                                                    [x]: {
                                                        'name': x,
                                                        'presentValue': ee.target.checked,
                                                        'boxType': e.okasBox_type
                                                    }
                                                }
                                            })
                                        }}
                                        checked={this.state.okasboxid.split(",").includes(e.okasBox_id.toString()) ? 'true' : this.checkresltimebox(x)}
                                        value={e.okasBox_id} /> : null}

                                </span>
                                {e.okasBox_type}
                            </td>
                            <td
                                className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"}
                            >
                                {e.okasBox_serialNo}
                            </td>
                        </tr>

                    )
                }
            });
            if (count === 0) {
                xx =
                    (<tr>
                        <td colSpan='4' className="text-center">
                            No box available in Inventory
                        </td>
                    </tr>)

            }
            return xx;
        }
        else if (type === 'hometheaterbox') {
            let count = 0;
            let xx1 = this.state.okasBoxData.map((e, index) => {
                if (e.okasBox_type === "Home Theatre Box" && (e.okasBox_assigned_to === 'unassigned' || this.state.okasboxid.split(",").includes(e.okasBox_id.toString()))) {
                    let x = e.okasBox_id
                    count++
                    return (
                        <tr key={index}>
                            {this.props.redux.globalVar.userTypeStyle === '1' && <td><input type="checkbox" name={e.okasBox_type}
                                onChange={(ee) => {
                                    console.log(ee.target.checked);
                                    this.setState({
                                        checkedBoxes: {
                                            ...this.state.checkedBoxes,
                                            [x]: {
                                                'name': x,
                                                'presentValue': ee.target.checked,
                                                'boxType': e.okasBox_type
                                            }

                                        }
                                    })
                                }}
                                checked={_.includes(this.state.okasboxid, e.okasBox_id) ? 'true' : this.checkresltimebox(x)}
                                value={e.okasBox_id} /></td>}
                            {/* <td>{e.okasBox_id}</td>  */}
                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"}>
                                <span className="input-checkbox-mobile">
                                    {this.props.windowWidth < 760 ? <input type="checkbox" name={e.okasBox_type}
                                        onChange={(ee) => {
                                            console.log(ee.target.checked);
                                            this.setState({
                                                checkedBoxes: {
                                                    ...this.state.checkedBoxes,
                                                    [x]: {
                                                        'name': x,
                                                        'presentValue': ee.target.checked,
                                                        'boxType': e.okasBox_type
                                                    }

                                                }
                                            })
                                        }}
                                        checked={_.includes(this.state.okasboxid, e.okasBox_id) ? 'true' : this.checkresltimebox(x)}
                                        value={e.okasBox_id} /> : null}
                                </span>
                                {e.okasBox_type}
                            </td>
                            <td className={this.props.windowWidth > 760 ? "" : "checkbox-mobile"}>{e.okasBox_serialNo}</td>
                        </tr>
                    )
                }
            });
            if (count === 0) {
                xx1 =
                    (<tr>
                        <td colSpan='4' className="text-center">
                            No box available in Inventory
                        </td>
                    </tr>)

            }
            return xx1;
        }
    }

    openNav = () => {
        this.setState({
            showSome: true
        })
    }

    memberLicensehandler = () => {
        if (this.state.modelxname === 'memberlicense') {
            let someData = this.state.memberLicenseTemp.map((e, index) => {
                return <tr key={index}>
                    {this.props.redux.globalVar.userTypeStyle === '1' && <td className={this.props.windowWidth > 760 ? "" : "checkbox-memberlicense"} ><input type="checkbox" name={e.id}
                        onChange={(ee) => {
                            let memberLicenseTemp = this.state.memberLicenseToUpload;
                            let newValue = this.state.memberLicenseTemp.map((kk) => {
                                if (kk.uniqueId === e.uniqueId) {
                                    return { uniqueId: e.uniqueId, status: ee.target.checked }
                                } else {
                                    return kk
                                }
                            })
                            this.setState({
                                memberLicenseTemp: newValue
                            })

                        }}
                        checked={e.status}
                    /></td>}
                    <td className={this.props.windowWidth > 760 ? "" : "checkbox-memberlicense"}>
                        <span className="input-checkbox-mobile">
                            {this.props.windowWidth < 760 ? <input type="checkbox" name={e.id}
                                onChange={(ee) => {
                                    let memberLicenseTemp = this.state.memberLicenseToUpload;
                                    let newValue = this.state.memberLicenseTemp.map((kk) => {
                                        if (kk.uniqueId === e.uniqueId) {
                                            return { uniqueId: e.uniqueId, status: ee.target.checked }
                                        } else {
                                            return kk
                                        }
                                    })
                                    this.setState({
                                        memberLicenseTemp: newValue
                                    })

                                }}
                                checked={e.status}
                            /> : null}
                        </span>
                        {e.uniqueId}
                    </td>
                </tr>
            })
            return someData
        }
    }

    memberLicenseCheckHandler = (key) => {
        let apiSet = new Set(this.state.memberLicenseTemp);
        return apiSet.has(key)
    }

    unassignedMemberLicense = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        fetch(`/we/we/weMemberLicenseAssignedApi/?userid=${localStorage.getItem('email')}`, {
            method: "GET",
            headers: headers,

        })
            .then(response => {
                // console.log(response)
                return response.json()
            })
            .then(memberLicenseData => {
                // console.log(memberLicenseData)
                let memData = memberLicenseData.map((e) => {
                    let uniqueId = e.licenseNo;
                    return {
                        uniqueId: uniqueId,
                        status: false
                    }
                })
                this.setState({
                    loader: false,
                    memberLicenseData: memData,
                    memberLicenseTemp: memData,
                    memberLicenseToUpload: memData
                })
            })
    }

    memberLicenseCount = () => {
        var r = 0;
        this.state.memberLicenseToUpload.forEach((e) => {
            if (e.status) {
                r++
            }
        })
        return r
    }

    handleChangeMemberLicense = () => {
        this.setState({
            memberLicenseToUpload: this.state.memberLicenseTemp,
        })
        this.onclosemodel();
    }


    assignedMemberLicense = () => {
        let data = this.state.okasBoxDataget.license_id.map((e, index) => {
            return (
                <tr key={index}>
                    {this.props.windowWidth > 760 ?
                        <td ><input
                            type="checkbox"
                            checked={true}
                        /></td> : null
                    }
                    <td className={this.props.windowWidth < 760 ? "checkbox-memberlicense" : ""}>
                        <span className="input-checkbox-mobile">
                            {this.props.windowWidth < 760 ?
                                <input
                                    type="checkbox"
                                    checked={true} /> : null}
                        </span>
                        {e}
                    </td>
                </tr>
            )
        })
        return data
    }

    selectAllCheckedBoxMemberLicense = (type) => {
        if (type === 'Member License') {
            let ml = this.state.memberLicenseTemp;
            let mlCount = 0;
            ml.forEach((e) => {
                if (e.status) {
                    mlCount++
                }
            })
            return mlCount === ml.length
        }
    }

    // onSelectChange = (operationMode, valueSelect) => {
    //    // console.log(valueSelect);
    //     if (valueSelect.label !== undefined) {
    //         this.setState({
    //             [operationMode]: valueSelect.value,
    //             error: false,
    //             [operationMode + "Error"]: false,
    //             reRenderManager: false
    //         })

    //     }
    // }


    onSelectChange = (operationMode, valueSelect) => {
        console.log("Selected Value:", valueSelect);

        if (valueSelect && valueSelect.label !== undefined) {
            this.setState(
                {
                    [operationMode]: valueSelect.value, // Ensure correct value is set
                    error: false,
                    [operationMode + "Error"]: false,
                    reRenderManager: false
                },
                () => {
                    console.log("Updated State:", this.state);
                }
            );
        }
    };



    selectAllCheckedBox = (boxType) => {
        let currentBoxes = this.state.okasBoxData.filter((box) => box.okasBox_type.includes(boxType) && box.okasBox_assigned_to === 'unassigned');
        let checkedBoxes = this.state.checkedBoxes;
        let checkedBoxesCount = 0;

        Object.keys(checkedBoxes).map((e) => {
            if (checkedBoxes[e].boxType.includes(boxType) && checkedBoxes[e].presentValue) {
                checkedBoxesCount++
            }
        })
        return currentBoxes.length === checkedBoxesCount

    }


    onAddClickHandler = (buttonaction) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')

        }
        // let building_id = new Date().valueOf().toString(); 
        let building_type = this.state.buildingtype;
        let building_name = this.state.buildingname.trim();
        let owner_name = this.state.ownername.trim();
        let owner_phone = this.state.ownerphone;
        let owner_email = this.state.owneremail;
        let address = this.state.buildingaddress;
        let no_of_floors = this.state.noOfFloors;
        let no_of_rooms = this.state.norooms;
        // let project_manager = this.state.projectmanager;
        let project_manager = this.state.project_manager;
        let pm_id = this.state.project_managerid;
        let okasBox_id = JSON.stringify(this.state.textvaluetest);
        okasBox_id = okasBox_id.replace("[", "");
        okasBox_id = okasBox_id.replace("]", "");
        // console.log(okasBox_id)

        if (okasBox_id) {
            okasBox_id = okasBox_id.concat(',');
            okasBox_id = okasBox_id.concat(this.state.okasboxid);
        } else {
            okasBox_id = this.state.okasboxid;
        }

        // console.log(okasBox_id)

        let okas_box_number1 = this.state.textvaluetest1;
        let okas_box_number2 = this.state.textvaluetest2;
        let okas_box_number4 = this.state.textvaluetest4;
        let okas_box_number5 = this.state.textvaluetest5;
        let okas_box_number7 = this.state.textvaluetest7;

        let license_id = this.state.okasBoxDataget.license_id;
        let countNewMemberLicense = 0;
        this.state.memberLicenseToUpload.forEach((license) => {
            if (license.status) {
                license_id.push(license.uniqueId)
                countNewMemberLicense++;
            }
        })

        let no_of_users = Number(this.state.nousers) + countNewMemberLicense;

        let tt = {
            // building_id,
            building_type,
            building_name,
            owner_name,
            owner_phone,
            owner_email,
            address,
            no_of_floors,
            no_of_users,
            project_manager,
            okasBox_id,
            license_id,
            pm_id
        };
        if (errorText('name', building_type) === 'Error') {
            this.setState({ error: 'Please enter building type', buildingtypeerror: 'errorfield selectlistss' })
        }
        else if (errorText('name', building_name) || ('name', building_name + '!@#$%^&*(){}[]') === 'Error') {
            this.setState({ error: 'Please enter a valid building name', buildingnameerror: 'errorfield' })
        }
        else if (errorText('name', owner_name) === 'Error') {
            this.setState({ error: "Enter owner's name", ownernameerror: 'errorfield', })
        } else if (errorText('name', owner_name) === 'Error1') {
            this.setState({ error: "Please enter valid owner's name", ownernameerror: 'errorfield', })
        } else if (errorText('phone', owner_phone) === 'Error') {
            this.setState({ error: 'Enter mobile number', phoneerror: 'errorfield', })
        } else if (errorText('phone', owner_phone) === 'Error1') {
            this.setState({ error: "Please enter Numeric Value in mobile number", phoneerror: 'errorfield', })
        } else if (errorText('phone', owner_phone) === 'Error2') {
            this.setState({ error: "Please enter a valid mobile number of 10 digits", phoneerror: 'errorfield', })
        } else if (errorText('phone', owner_phone) === 'Error3') {
            this.setState({ error: "Please enter a valid mobile number start from 7,8,9", phoneerror: 'errorfield', })
        } else if (errorText('email', owner_email) === 'Error') {
            this.setState({ error: "Enter an email", emailerror: 'errorfield', })
        } else if (errorText('email', owner_email) === 'Error1') {
            this.setState({ error: "Please enter a valid email example(XXXXXXX@XXXXXX.XXX)", emailerror: 'errorfield', })
        } else if (errorText('address', address) === 'Error') {
            this.setState({ error: 'Please enter a valid building address', buildingaddresserror: 'errorfield', })
        } else if (errorText('empty', no_of_floors) === 'Error') {
            this.setState({ error: 'Please select no. of floors', noOfFloorsError: 'errorfield selectlistss' })
        } else if (errorText('empty', no_of_users) === 'Error') {
            this.setState({ error: 'Please select no. of users', nouserserror: 'errorfield selectlistss' })
        } else if (errorText('empty', no_of_rooms) === 'Error') {
            this.setState({ error: 'Please select no. of rooms', noroomserror: 'errorfield selectlistss' })
        } else if (okas_box_number1.length > 0) {
            this.setState({ error: 'You Can select only one master controller', noroomserror: 'errorfield selectlistss' })
        } else if (okas_box_number7.length > 0) {
            this.setState({ error: 'You Can select only one core OKAS', noroomserror: 'errorfield selectlistss' })
        } else {
            this.setState({ disabledvalue: 'disabled', })
            this.setState({ loader: true, })
            fetch(`/we/we/projectBuildingApi_detail/${this.state.building_id}`, {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => response.json())
                .then(data => {
                    var dataadded = "dataadded";
                    localStorage.setItem("dataadded", dataadded);
                    if (buttonaction === 'add') {
                        // const history = createBrowserHistory({ forceRefresh: true });
                        window.location.href = '/projectdetail';

                    } else if (buttonaction === 'addanother') {
                        // const history = createBrowserHistory({ forceRefresh: true });
                        window.location.href = '/projectdetailadd';
                    }

                })
            this.setState({
                loader: true,
            })
        }
    }
    render() {

        return Style.it(`
            @media only screen and (max-width: 760px){
          td:nth-of-type(1):before { content: "BOX TYPE"; }
          td.checkbox-memberlicense:nth-of-type(1):before { content: "MEMBER LICENSE"; }
          td:nth-of-type(2):before { content: "SERIAL"; }
          td:nth-of-type(3):before { content: "EMAIL"; }
          td:nth-of-type(4):before { content: "ADDRESS"; }
          td:nth-of-type(5):before { content: "BOXES"; }
          td:nth-of-type(6):before { content: "DELETE"; }
        }`,

            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop ? "hidden" : ""
                }}
            >
                {this.state.loader ? <Loader /> : null}
                <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                    <div className="inblksuccfull"><img src={Success} /></div>
                    <div className="inblksucc1">
                        SUCCESS !
                        <a className="successmsgcross"><RxCross2 size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                    </div>
                </div>
                <h3>Edit Project</h3>
                <div className={this.state.error ? 'errormsgbox' : 'errormsgbox errormsgboxnone'}  >
                    <div className="inblksucc"><img src={Error} /></div>
                    <div className="inblksucc1">
                        {this.state.error} !
                        <a className="successmsgcross"><RxCross2 size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                    </div>
                </div>
                <form action="javascript:void(0)"
                //  onSubmit={this.onAddClickHandler.bind(this,'add')}
                >
                    <div className="row">
                        <div className="rightboxforma col-lg-6" style={{ marginTop: '28px' }}>
                            <div className="" style={{ marginTop: '5%' }}>
                                {this.state.showSome ? <span className="">BUILDING ID</span> : null}

                                <div className="p-0 custom-margin-mobile" style={{ marginBottom: "30px" }}>

                                    <TextField
                                        label="Building ID"
                                        type="text"
                                        value={this.state.building_id}
                                        name="buildingtype"
                                        variant="standard"
                                        fullWidth
                                        InputProps={{ readOnly: true }} // Makes it read-only
                                        InputLabelProps={{ shrink: !!this.state.building_id }} // Ensures label stays up if value exists
                                        className={this.state.buildingnameerror ? this.state.buildingnameerror : ""}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 100) {
                                                this.setState({
                                                    buildingtype: e.target.value,
                                                    error: false,
                                                    buildingnameerror: false,
                                                });
                                            }
                                        }}
                                    />

                                </div>
                                <div className="p-0" style={{ marginBottom: "8px" }}>
                                    <TextField
                                        label="Building Type"
                                        type="text"
                                        value={this.state.buildingtype}
                                        name="buildingtype"
                                        variant="standard"
                                        fullWidth
                                        InputProps={{ readOnly: true }} // Makes it read-only
                                        InputLabelProps={{ shrink: !!this.state.buildingtype }} // Ensures label stays up if value exists
                                        className={this.state.buildingnameerror ? this.state.buildingnameerror : ""}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 100) {
                                                this.setState({
                                                    buildingtype: e.target.value,
                                                    error: false,
                                                    buildingnameerror: false,
                                                });
                                            }
                                        }}
                                    />

                                </div>


                                {/* <Input label="Building Type" type="text" name="buildingtype" placeholder="Building Type"  className={this.state.buildingtypeerror ? this.state.buildingtypeerror : ""}
                    onChange={(e)=>{
                        this.setState({
                            buildingtype: e.target.value
                        },()=>console.log(this.state.buildingtype))

                    }}
                    />   <br/> */}
                                <TextField sx={{ marginTop: "30px" }}
                                    label="Building Name"
                                    type="text"
                                    value={this.state.buildingname}
                                    name="buildingname"
                                    variant="standard"
                                    fullWidth
                                    placeholder="Building Name"
                                    InputLabelProps={{ shrink: !!this.state.buildingname }} // Keeps label up if value exists
                                    className={this.state.buildingnameerror ? this.state.buildingnameerror : ""}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 100) {
                                            this.setState({
                                                buildingname: e.target.value,
                                                error: false,
                                                buildingnameerror: false,
                                            });
                                        }
                                    }}
                                />

                                <TextField sx={{ marginTop: "30px" }}
                                    label="Owner Name"
                                    type="text"
                                    name="ownername"
                                    variant="standard"
                                    fullWidth
                                    placeholder="Owner Name"
                                    value={this.state.ownername}
                                    InputLabelProps={{ shrink: !!this.state.ownername }} // Keeps label up if value exists
                                    className={this.state.ownernameerror ? this.state.ownernameerror : ""}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 100) {
                                            this.setState({
                                                ownername: e.target.value,
                                                error: false,
                                                ownernameerror: false,
                                            });
                                        }
                                    }}
                                />
                                <TextField sx={{ marginTop: "30px" }}
                                    label="Owner Phone"
                                    type="text"
                                    name="ownerphone"
                                    variant="standard"
                                    fullWidth
                                    placeholder="Owner Phone"
                                    value={this.state.ownerphone}
                                    InputLabelProps={{ shrink: !!this.state.ownerphone }} // Keeps label up if value exists
                                    className={this.state.ownerphoneerror ? this.state.ownerphoneerror : ""}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value.length <= 10 && (/^[0-9\b]+$/.test(value) || value === '')) {
                                            this.setState({
                                                ownerphone: value,
                                                error: false,
                                                ownerphoneerror: false,
                                            });
                                        }
                                    }}
                                />
                                <TextField sx={{ marginTop: "30px" }}
                                    label="Owner Email"
                                    type="email"
                                    name="owneremail"
                                    variant="standard"
                                    fullWidth
                                    placeholder="Owner Email"
                                    value={this.state.owneremail}
                                    InputLabelProps={{ shrink: !!this.state.owneremail }} // Keeps label up if value exists
                                    className={this.state.owneremailerror ? this.state.owneremailerror : ""}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 100) {
                                            this.setState({
                                                owneremail: e.target.value,
                                                error: false,
                                                owneremailerror: false,
                                            });
                                        }
                                    }}
                                />

                                <TextField sx={{ marginTop: "30px" }}
                                    label="Building Address"
                                    type="text"
                                    name="buildingaddress"
                                    variant="standard"
                                    fullWidth
                                    placeholder="Building Address"
                                    value={this.state.buildingaddress}
                                    InputLabelProps={{ shrink: !!this.state.buildingaddress }} // Keeps label up if value exists
                                    className={this.state.buildingaddresserror ? this.state.buildingaddresserror : ""}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 100) {
                                            this.setState({
                                                buildingaddress: e.target.value,
                                                error: false,
                                                buildingaddresserror: false,
                                            });
                                        }
                                    }}
                                />


                                {/* {this.state.noOfFloors !== "" ?
                                 <FormControl
                                    sx={{ marginTop: "30px", }}
                                    fullWidth
                                    variant="standard"
                                    error={!!this.state.noOfFloorsError}
                                >
                                    <InputLabel>No. of Floors</InputLabel>
                                    <Select
                                        key={this.state.noOfFloors} // Forces component to re-render

                                        value={this.state.noOfFloors || ""} // Ensure controlled component
                                            onChange={(e) => this.onSelectChange("noOfFloors", { value: e.target.value, label: e.target.value })}

                                        // onChange={(e) => this.onSelectChange("noOfFloors", { value: e.target.value })}
                                        displayEmpty
                                    >
                                        <MenuItem value="" disabled>
                                            Please select number of floors
                                        </MenuItem>
                                        {noOfFloors.map((floor) => (
                                            <MenuItem key={floor.value} value={floor.value}>
                                                {floor.label}
                                            </MenuItem>
                                        ))}
                                    </Select>

                                    {this.state.noOfFloorsError && (
                                        <FormHelperText>{this.state.noOfFloorsError}</FormHelperText>
                                    )}
                                </FormControl>
                                    : null} */}

                                {this.state.noOfFloors !== "" ? (
                                    <>
                               
                                        <FormControl
                                            sx={{ marginTop: "30px", marginBottom: "20px" }}
                                            fullWidth
                                            variant="standard"
                                            // error={!!this.state.noOfFloorsError?.trim()}
                                        >
                                            <InputLabel>No. of Floors</InputLabel>
                                            <Select
                                                key={this.state.noOfFloors}
                                                value={this.state.noOfFloors || ""}
                                                onChange={(e) =>
                                                    this.onSelectChange("noOfFloors", {
                                                        value: e.target.value,
                                                        label: e.target.value,
                                                    })
                                                }
                                                displayEmpty
                                            >
                                                <MenuItem value="" disabled>
                                                    Please select number of floors
                                                </MenuItem>
                                                {noOfFloors.map((floor) => (
                                                    <MenuItem key={floor.value} value={floor.value}>
                                                        {floor.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>

                                            {/* {this.state.noOfFloorsError?.trim() && (
                                                <FormHelperText>{this.state.noOfFloorsError}</FormHelperText>
                                            )} */}
                                        </FormControl>
                                    </>
                                ) : null}



                                <div style={{ pointerEvents: "none", marginTop: '30px' }} >
                                    <TextField
                                        label="No of Users"
                                        type="text"
                                        name="noOfUsers"
                                        variant="standard"
                                        fullWidth
                                        value={this.state.nousers + this.memberLicenseCount()} // Computed value
                                        placeholder="No of Users"
                                        InputProps={{ readOnly: true }} // Makes it non-editable
                                    />
                                </div>
                                {/* <div className="md-form">
                        <select label="No of Users" type="number" name="nousers" placeholder="No of Users "
                            className={this.state.nouserserror ? this.state.nouserserror : "selectlistss" }
                            onChange={(e)=>{
                            this.setState({
                            nousers: e.target.value,
                            error: false,
                            nouserserror: false,
                            })
                            }}
                            >
                            <option className="selectlistfirstelement" value=''></option>
                            <option className={this.state.nouserstemp>3?"selectlistfirstelement":null} selected={this.state.nousers==3?"true":null}>03</option>
                            <option className={this.state.nouserstemp>5?"selectlistfirstelement":null} selected={this.state.nousers==5?"true":null}>05</option>
                            <option className={this.state.nouserstemp>10?"selectlistfirstelement":null} selected={this.state.nousers==10?"true":null}>10</option> 
                        </select>
                        <label className={this.state.nousers=='' ? null : 'active' }>No of Users</label>
                    </div> */}
                                <br />
                            </div>
                        </div>
                        <div className="leftboxforma col-lg-6 mobile-device-padding-zero">
                            <span className="headprojectaddbox">OKAS Boxes</span>
                            <div className="leftboxformdiv">
                                {/* <div className="un" 
                            // style={{    padding: '0% 20%'}}
                        > 

                            <input onClick={(e)=>{
                                this.setState({
                                    radio: 'mastercontrollerbox',  
                                    checkedBoxes:'',
                                    textvaluetest:'',
                                    textvaluetest1:'',
                                    textvaluetest2:'',
                                    textvaluetest3:'',
                                    textvaluetest4:'',
                                    textvaluetest5:'',
                                    checkedBoxestemp:'', 
                                })
                            } } style={{width: '15px', height: '15px'}} checked={this.state.radio==='mastercontrollerbox' ? true : false} label="Master Controller" type="radio" id="radio2" name="mastercontrollerbox"/><b style={{marginLeft: "8px"}}>Multiple Box Solution</b>
                        <span className="pull-right">
                            <input onClick={(e)=>{
                                this.setState({
                                    radio: 'hometheaterbox', 
                                    checkedBoxes:'',
                                    textvaluetest:'',
                                    textvaluetest1:'',
                                    textvaluetest2:'',
                                    textvaluetest3:'',
                                    textvaluetest4:'',
                                    textvaluetest5:'',
                                    checkedBoxestemp:'',

                                })
                            } }  style={{width: '15px', height: '15px'}}  checked={this.state.radio==='hometheaterbox' ? true : false} label="Home Theatre Box" type="radio" id="radio2" name="hometheaterbox"/><b style={{marginLeft: "8px"}}>Single Box Solution</b>
</span>
                        </div> */}
                                {this.state.demobox1 || this.state.demobox7 ?

                                    <div style={{ minHeight: "240px" }} >
                                        {/* <div className="un">
                                            <span className="icon-box"><img src={mc} /></span>
                                            Master Studio (
                                            {this.state.textvaluetest1.length + this.state.demobox1 === 0 ? 0 : this.state.textvaluetest1.length + this.state.demobox1}
                                            )</div>
                                        <div className="addbuttonasd"><a className="button" onClick={this.onopenmodel.bind(this, 'Master Controller', 'mastercontrollerbox')}>{this.props.redux.globalVar.userTypeStyle === '1' ? 'Add' : 'View'}</a></div> */}
                                        {/* Master Studio Section */}
                                        <div className="un">
                                            <span className="icon-box">
                                                <img src={mc} alt="Master Studio Icon" />
                                            </span>
                                            Master Studio (
                                            {this.state.textvaluetest1.length + this.state.demobox1 === 0
                                                ? 0
                                                : this.state.textvaluetest1.length + this.state.demobox1}
                                            )
                                        </div>
                                        <div className="addbuttonasd">
                                            <a
                                                className={`button ${this.state.textvaluetest7.length + this.state.demobox7 > 0 ? "disabled" : ""}`}
                                                onClick={() => {
                                                    if (this.state.textvaluetest7.length + this.state.demobox7 === 0) {
                                                        this.onopenmodel("Master Controller", "mastercontrollerbox");
                                                    }
                                                }}
                                                style={{
                                                    pointerEvents: this.state.textvaluetest7.length + this.state.demobox7 > 0 ? "none" : "auto",
                                                    opacity: this.state.textvaluetest7.length + this.state.demobox7 > 0 ? 0.5 : 1,
                                                }}
                                            >
                                                {this.props.redux.globalVar.userTypeStyle === "1" ? "Add" : "View"}
                                            </a>
                                        </div>

                                        {/* Core OKAS BOX */}
                                        {/* 
                                        <div className="un">
                                            <span className="icon-box"><img src={mc} /></span>
                                            Core OKAS (
                                            {this.state.textvaluetest7.length + this.state.demobox7 === 0 ? 0 : this.state.textvaluetest7.length + this.state.demobox7}
                                            )</div>
                                        <div className="addbuttonasd"><a className="button" onClick={this.onopenmodel.bind(this, 'Core Okas', 'coreOkasbox')}>{this.props.redux.globalVar.userTypeStyle === '1' ? 'Add' : 'View'}</a></div> */}


                                        {/* Core OKAS Section */}
                                        <div className="un">
                                            <span className="icon-box">
                                                <img src={mc} alt="Core OKAS Icon" />
                                            </span>
                                            Core OKAS (
                                            {this.state.textvaluetest7.length + this.state.demobox7 === 0
                                                ? 0
                                                : this.state.textvaluetest7.length + this.state.demobox7}
                                            )
                                        </div>
                                        <div className="addbuttonasd">
                                            <a
                                                className={`button ${this.state.textvaluetest1.length + this.state.demobox1 > 0 ? "disabled" : ""}`}
                                                onClick={() => {
                                                    if (this.state.textvaluetest1.length + this.state.demobox1 === 0) {
                                                        this.onopenmodel("Core Okas", "coreOkasbox");
                                                    }
                                                }}
                                                style={{
                                                    pointerEvents: this.state.textvaluetest1.length + this.state.demobox1 > 0 ? "none" : "auto",
                                                    opacity: this.state.textvaluetest1.length + this.state.demobox1 > 0 ? 0.5 : 1,
                                                }}
                                            >
                                                {this.props.redux.globalVar.userTypeStyle === "1" ? "Add" : "View"}
                                            </a>
                                        </div>
                                        <div className="un"> <span className="icon-box"><img src={vodb} /></span>Media Studio (
                                            {this.state.textvaluetest2.length + this.state.demobox2 === 0 ? 0 : this.state.textvaluetest2.length + this.state.demobox2}
                                            )</div><div className="addbuttonasd"><a className="button" onClick={this.onopenmodel.bind(this, 'VOD', 'vodbox')}>{this.props.redux.globalVar.userTypeStyle === '1' ? 'Add' : 'View'}</a></div>

                                        {/* <div className="un"><span className="icon-box"><img src={uvodb} /></span>Ultra Media Studio (
                                            {this.state.textvaluetest3.length + this.state.demobox3 === 0 ? 0 : this.state.textvaluetest3.length + this.state.demobox3}
                                            )</div><div className="addbuttonasd"><a className="button" onClick={this.onopenmodel.bind(this, 'UVOD Box', 'UVOD Box')}>{this.props.redux.globalVar.userTypeStyle === '1' ? 'Add' : 'View'}</a></div> */}

                                        <div className="un"><span className="icon-box"><img src={ab} /></span>Music Studio (
                                            {this.state.textvaluetest4.length + this.state.demobox4 === 0 ? 0 : this.state.textvaluetest4.length + this.state.demobox4}
                                            )</div><div className="addbuttonasd"><a className="button" onClick={this.onopenmodel.bind(this, 'Audio', 'musicbox')}>{this.props.redux.globalVar.userTypeStyle === '1' ? 'Add' : 'View'}</a></div>

                                        <div className="un">
                                            <span className="icon-box"><img src={mc} /></span>
                                            Control Studio (
                                            {this.state.textvaluetest6.length + this.state.demobox6 === 0 ? 0 : this.state.textvaluetest6.length + this.state.demobox6}
                                            )</div>
                                        <div className="addbuttonasd"><a className="button" onClick={this.onopenmodel.bind(this, 'Control Studio', 'controlStudio')}>{this.props.redux.globalVar.userTypeStyle === '1' ? 'Add' : 'View'}</a></div>

                                        <div className="un"><span className="icon-box"><img src={ml} /></span>Member License (
                                            {this.memberLicenseCount() + this.state.okasBoxDataget.license_id.length}
                                            )</div><div className="addbuttonasd"><a className="button" onClick={this.onopenmodel.bind(this, 'Additional Member', 'memberlicense')}>{this.props.redux.globalVar.userTypeStyle === '1' ? 'Add' : 'View'}</a></div>
                                    </div>
                                    : null}
                                {/* {this.state.demobox5 ?
                                    <div style={{ minHeight: "190px" }} >
                                        <div className="un">Home Theatre Box (
                                            {this.state.textvaluetest5.length + this.state.demobox5 === 0 ? 0 : this.state.textvaluetest5.length + this.state.demobox}
                                            )</div><div className="addbuttonasd"><a className="button" onClick={this.onopenmodel.bind(this, 'Home Theatre', 'hometheaterbox')}>{this.props.redux.globalVar.userTypeStyle === '1' ? 'Add' : 'View'}</a></div>
                                    </div>
                                    : null} */}
                                <div className='totalokasboxnumbermargin'>
                                    <div className="totalokasboxnumber">Total no. of OKAS Boxes  </div><div className="addbuttonasd"> {this.state.textvaluetest.length + this.state.okasboxid.split(',').length === 0 ? 0 : this.state.textvaluetest.length + this.state.okasboxid.split(',').length}Boxes</div>
                                </div>
                            </div>
                            <div className="modal-body modfields " style={{ paddingTop: '10px' }}>
                                <div style={{ marginTop: "15px" }}>
                                    <div className="md-form">
                                        <TextField label="Project Manager" variant="standard" type="text" value={this.state.project_manager} name="projectmanager" placeholder="Project Manager "
                                            className={this.state.projectmanagererror ? this.state.projectmanagererror : "selectlistss"}
                                            readonly='true' onChange={(e) => {
                                                if (e.target.value.length <= 100) {
                                                    this.setState({
                                                        projectmanager: e.target.value,
                                                        error: false,
                                                        projectmanagererror: false,
                                                    })
                                                }
                                            }
                                            }
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="md-form">
                                    <TextField
                                        label="Office Address"
                                        type="text"
                                        value={this.state.office_address}
                                        name="officeaddress"
                                        placeholder="Office Address"
                                        variant="standard"
                                        InputProps={{ readOnly: true }} // MUI way to make it read-only
                                        className={this.state.officeaddresserror ? this.state.officeaddresserror : "selectlistss"}
                                        onChange={(e) => {
                                            this.setState({
                                                office_address: e.target.value, // Ensure state key is correct
                                                error: false,
                                                officeaddresserror: false,
                                            });
                                        }}
                                    />
                                </div>
                                <br />
                                {this.state.projectmanager ? <br></br> : ""}
                                {/* test */}
                                <input type="hidden" name="okasbox1" id="okasbox1" value={this.state.textvaluetest1} placeholder=""
                                    onChange={(e) => {
                                        this.setState({
                                            okasbox1: e.target.value
                                        })

                                    }}
                                />
                                <input type="hidden" name="okasbox2" id="okasbox2" value={this.state.textvaluetest2} placeholder=""
                                    onChange={(e) => {
                                        this.setState({
                                            okasbox2: e.target.value
                                        })

                                    }}
                                />
                                <input type="hidden" name="okasbox3" id="okasbox3" value={this.state.textvaluetest3} placeholder=""
                                    onChange={(e) => {
                                        this.setState({
                                            okasbox3: e.target.value
                                        })

                                    }}
                                />
                                <input type="hidden" name="okasbox4" id="okasbox4" value={this.state.textvaluetest4} placeholder=""
                                    onChange={(e) => {
                                        this.setState({
                                            okasbox4: e.target.value
                                        })

                                    }}
                                />
                                <input type="hidden" name="okasbox5" id="okasbox5" value={this.state.textvaluetest5} placeholder=""
                                    onChange={(e) => {
                                        this.setState({
                                            okasbox5: e.target.value
                                        })

                                    }}
                                />
                                <input type="hidden" name="okasbox6" id="okasbox6" value={this.state.textvaluetest6} placeholder=""
                                    onChange={(e) => {
                                        this.setState({
                                            okasbox6: e.target.value
                                        })

                                    }}
                                />
                                <input type="hidden" name="okasbox7" id="okasbox7" value={this.state.textvaluetest7} placeholder=""
                                    onChange={(e) => {
                                        this.setState({
                                            okasbox7: e.target.value
                                        })

                                    }}
                                />

                                {/* testend */}
                                <input type="hidden" name="okasboxid" id="okasboxid" value={this.state.textvaluetest} placeholder=""
                                    onChange={(e) => {
                                        this.setState({
                                            okasboxid: e.target.value
                                        })
                                    }}
                                />
                            </div>

                        </div>
                        <br />

                        <span className="fieldmend"></span>
                    </div>
                    {/* {this.state.error!=='' ? <div className="alert alert-danger">{this.state.error}</div> : null }  */}
                    <div className="modal-footer">
                        <Link to="/projectdetail"><button type="button" className="btn allbtn" data-dismiss="modal">Cancel</button> </Link>
                        {/* <button type="button"   className="btn addbtn allbtn"  onClick={this.onAddClickHandler.bind(this,'addanother')}>Add Another</button> */}
                        <button type="submit" disabled={this.state.disabledvalue || this.state.okasboxid ? this.state.disabledvalue : null} className="btn btn-primary allbtn" onClick={this.onAddClickHandler.bind(this, 'add')}>Update</button>
                    </div>
                </form>
                {/* modals start */}
                {this.state.showmodels ?
                    //  <div className="selfmodal fade modal-dialog-centered" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                    <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog"
                            style={{
                                width: this.props.windowWidth > 760 ? "50%" : "60%",
                            }}
                        >
                            <div className="selfmodal-content">
                                <div className="modal-header">
                                    <button type="submit" className="close" data-dismiss="modal"
                                        onClick={this.onclosemodel.bind(this)}
                                    >&times;</button>
                                    {this.state.modelxname !== 'memberlicense' ? <h3 className="modal-title">Add {this.state.modelname === 'Master Controller' ? 'Master Studio'
                                        : this.state.modelname === 'VOD' ? 'Media Studio'
                                            // : this.state.modelname === 'UVOD Box' ? 'Ultra Media Studio'
                                            : this.state.modelname === 'Audio' ? 'Music Studio'
                                                : this.state.modelname}
                                        {/* {this.state.modelname === 'UVOD Box' ? "" : "Box"} */}
                                        {/* <span className="breadcrum">Project Detail > Add New Project > Add New {this.state.modelname} Box</span> */}
                                    </h3> :
                                        <h3 className="modal-title">Add {this.state.modelname}
                                            {/* <span className="breadcrum">Project Detail > Add New Project > Add New {this.state.modelname}</span> */}
                                        </h3>}
                                </div>
                                {this.state.modelxname !== 'memberlicense' ? <div className="modal-body" >
                                    <TableContainer component={Paper}>
                                        <Table className={"tablecontent"}>
                                            <TableHead>
                                                <TableRow>
                                                    {this.props.redux.globalVar.userTypeStyle === "1" && (
                                                        <TableCell>
                                                            <Checkbox style={{ color: 'white' }}
                                                                onChange={(ee) => {
                                                                    let allBoxes = this.state.okasBoxData.filter(
                                                                        (box) =>
                                                                            box.okasBox_assigned_to === "unassigned" &&
                                                                            box.okasBox_type.includes(this.state.modelname)
                                                                    );

                                                                    let x = { ...this.state.checkedBoxes };
                                                                    allBoxes.forEach((event) => {
                                                                        x[event.okasBox_id] = {
                                                                            name: event.okasBox_id,
                                                                            presentValue: ee.target.checked,
                                                                            boxType: event.okasBox_type,
                                                                        };
                                                                    });

                                                                    this.setState({ checkedBoxes: x });
                                                                    this.selectAllCheckedBox(this.state.modelname);
                                                                }}
                                                                checked={this.selectAllCheckedBox(this.state.modelname)}
                                                            />
                                                        </TableCell>
                                                    )}
                                                    <TableCell sx={{ color: 'white', fontSize: '12px' }}><b>BOX TYPE</b></TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: '12px' }}><b>SERIAL NO.</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.renderTableData(this.state.modelxname) ? (
                                                    this.renderTableData(this.state.modelxname)
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={3} align="center">
                                                            No box available in Inventory
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div> : <div className="modal-body"  >
                                    <TableContainer component={Paper}>
                                        <Table className={"tablecontent"}>
                                            <TableHead>
                                                <TableRow>
                                                    {this.props.redux.globalVar.userTypeStyle === "1" && (
                                                        <TableCell sx={{ color: 'white' }}>
                                                            <Checkbox style={{ color: 'white' }}
                                                                onChange={(ee) => {
                                                                    let mlStatusUpdated = this.state.memberLicenseTemp.map((ml) => ({
                                                                        ...ml,
                                                                        status: ee.target.checked,
                                                                    }));
                                                                    this.setState({ memberLicenseTemp: mlStatusUpdated });
                                                                }}
                                                                checked={this.selectAllCheckedBoxMemberLicense("Member License")}
                                                            />
                                                        </TableCell>
                                                    )}
                                                    <TableCell sx={{ color: 'white', fontSize: '12px' }} align="center"><b>Member License</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.memberLicenseData.length === 0 && this.state.okasBoxDataget.license_id.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={2} align="center">
                                                            No member license available in inventory.
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    <>
                                                        {this.assignedMemberLicense()}
                                                        {this.memberLicensehandler()}
                                                    </>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>}
                                <br />
                                <div className="modal-footer align-btn-mobile">
                                    {this.props.redux.globalVar.userTypeStyle === '1' ? <button type="button"
                                        onClick={this.onclosemodel.bind(this)}
                                        className="btn allbtn" data-dismiss="modal">Cancel</button> : <button type="submit"
                                            onClick={this.onclosemodel.bind(this)}
                                            className="btn btn-primary allbtn" data-dismiss="modal">Close</button>}
                                    {this.props.redux.globalVar.userTypeStyle === '1' ? <button type="submit"
                                        onClick={this.state.modelxname !== 'memberlicense' ? this.handleChange.bind(this) : this.handleChangeMemberLicense.bind(this)}
                                        className="btn btn-primary allbtn" data-dismiss="modal">
                                        Add
                                    </button> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        userNameStyleActivate: (data) => dispatch({ type: ActionTypes.USERNAMESTYLE, data: data }),
        reuserNameStyleActivate: (data) => dispatch({ type: ActionTypes.REUSERNAMESTYLE, data: data }),
        userTypeStyleActivate: (data) => dispatch({ type: ActionTypes.USERTYPESTYLE, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetailEditPage);
